import { render, staticRenderFns } from "./RosterLeavesListApproved.vue?vue&type=template&id=39295fca"
import script from "./RosterLeavesListApproved.vue?vue&type=script&lang=js"
export * from "./RosterLeavesListApproved.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports